import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getAnggotaKap = 'anggota-kap';
const postAnggotaKap = 'anggota-kap';
const deleteAnggotaKap = 'anggota-kap/';
const getDataAnggotaNonKap = 'anggota-kap/data-anggota';

class AnggotaKapService {

    getAnggotaKap(pageNo, pageSize, filter, idKap) {
        return axios.get(API_URL + getAnggotaKap, {
            params: {
                pageNo: pageNo,
                pageSize: pageSize,
                filter: filter,
                idKap: idKap
            },
            headers: authHeader()
        });
    }

    postAnggotaKap(formdata) {
        return axios.post(API_URL + postAnggotaKap, formdata, {
            headers: authHeader()
        });
    }

    deleteAnggotaKap(id) {
        return axios.delete(API_URL + deleteAnggotaKap + id, {
            headers: authHeader()
        });
    }

    getDataAnggotaNonKap() {
        return axios.get(API_URL + getDataAnggotaNonKap, {
            headers: authHeader()
        });
    }

}

export default new AnggotaKapService();